"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function () { return m[k]; } });
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule)
        return mod;
    var result = {};
    if (mod != null)
        for (var k in mod)
            if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k))
                __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// import { resolve } from "path";
const vue_1 = require("vue");
const _ = __importStar(require("lodash"));
//
// CRUD mixin
//
const quasar_1 = require("quasar");
// import { nextTick } from 'q'
// Dependencies (global):
// - Quasar
// - VueApollo
// - uiMixin ( flash(), progressbar(), uiUndoAction() )
const uiMixin_1 = __importDefault(require("./uiMixin"));
exports.default = vue_1.defineComponent({
    setup() {
        const $q = quasar_1.useQuasar();
        return { $q };
    },
    /* INFO: redirectTo: 'prev' ==> on VueRouter4 / Vue3 -> is not executed from mxins; must be defined on right component:
    onBeforeRouteEnter(to: any, from: any, next: any) {
      console.log('beforeRouteEnter')
      alert('beforeRouteEnter')
      // to track previous page url
      next((vm: any) => {
        vm.prevRoute = from
        console.log(vm.prevRoute)
        next()
      })
    },
    */
    mixins: [uiMixin_1.default],
    data() {
        return {
            // operation mode: [ create | read | update | delete ]
            formMode: 'create',
            // operations scope; component item(s) object/array name
            crudScope: 'items',
            // model queries/mutations definitions
            operations: {
                create: null,
                read: null,
                update: null,
                delete: null
            },
            // use VueApollo cache  [ true | false ]
            // NOTE: If not used apollo cache component UI MUST disable possibility to execute any operation
            //        until running currently operation mutation/refetch query will finish.
            //       Simultaneously mutations/queries are not supported if apolloCache is disabled (=false).
            //       Component inputs/form should have set `:disabled="syncing"` (watch for this mixin `syncing` computed property)
            apolloCache: {
                create: true,
                read: true,
                update: true,
                delete: true
            },
            loading: false,
            saving: false,
            deleting: false,
            valid: true,
            invalidOnServer: [],
            invalidOnServerValues: [],
            // action confirmation status prompt (before action)
            promptConfirm: false,
            promptAction: null,
            confirmDelete: true,
            selected: [],
            dialog: null,
            // for actions require confirmation before or any postponed crud action
            postponedActionArgs: {
                model: {} // model data to be processed
            },
            deleted: { default: [] },
            // initially read from Server model object data clone (updated only if read from server)
            initialModelObject: null,
            // reference to crud form model object data (ex. this.User ); required for server-side validation results presenting
            modelObjectName: null,
            // model upload random id (used when create operation)
            uid: quasar_1.uid(),
            // common label shown on messages for user
            label: 'Record',
            // where to redirect after success
            // [ url path string | object | 'prev'=>(go to previous page in routing) ]
            redirectTo: null,
            prevRoute: null,
            // message shown when one or more form inputs are invalid
            msgInvalid: 'Please amend invalid data',
            // for form split on several tabs validation before submit
            tabPanels: null,
            tabs2validate: false,
            tabPanelOnSubmit: null,
            tabAlert: {} // mark tabs with invalid input values with alert dot; properties are tabs names
        };
    },
    computed: {
        /**
         * Is current form exchange data with server
         *
         * @returns
         */
        syncing() {
            return !!(this.loading || this.saving || this.deleting);
        }
    },
    watch: {
        syncing(v) {
            this.progressbar(v);
        }
    },
    methods: {
        //
        // CRUD actions
        //
        /**
         * Define crud functionality (on component `create`)
         *
         * @param read          apollo query definition object for read modified data stock (index/listing/other)
         * @param model         apollo Type (model)
         * @param id            model id
         * @param apolloCache   apollo cache usage
         */
        async crud({ read, readOnLoad = false, scope = 'items', 
        // model,
        // id = 0,
        apolloCache, label = 'Record', redirectTo, modelObjectName } = {}) {
            /*if (model && id) {
              this[model].id = id || null
              this.formMode = this[model].id ? 'update' : 'create'
            }*/
            this.label = label;
            this.redirectTo = redirectTo;
            this.modelObjectName = modelObjectName;
            if (apolloCache) {
                if (typeof (apolloCache) === 'boolean') {
                    this.apolloCache = {
                        create: apolloCache,
                        read: apolloCache,
                        update: apolloCache,
                        delete: apolloCache
                    };
                }
                else {
                    this.apolloCache = Object.assign(Object.assign({}, this.apolloCache), apolloCache);
                }
            }
            if (read) {
                this.operations.read = read;
                if (scope) {
                    this.crudScope = scope;
                }
                if (readOnLoad) {
                    await this._read();
                }
            }
        },
        async _read(refetch = false, silent = false) {
            refetch = !!(refetch || !this.apolloCache.read);
            return new Promise((resolve, reject) => {
                this.formMode = 'read';
                this.loading = !silent ? true : false;
                if (typeof (this.operations.read) === 'string') { // Apollo SmartQuery defined on target component
                    let fetchPolicy;
                    if (refetch) {
                        fetchPolicy = 'network-only';
                    }
                    this.$apollo.queries[this.crudScope].setOptions({
                        fetchPolicy: fetchPolicy,
                        result({ data }) {
                            if (process.env.DEV) {
                                console.log('QUERY: ' + this._getDataObjectName(data));
                                console.log(data[this._getDataObjectName(data)]);
                            }
                            const scopeData = data[this._getDataObjectName(data)];
                            resolve(scopeData);
                        }
                    });
                    this.$apollo.queries[this.crudScope].refetch();
                }
                else { // internal query
                    this.$apollo.query(Object.assign(Object.assign({}, this.operations.read), {
                        watchLoading: () => {
                            this.loading = !silent ? true : false;
                        },
                        fetchPolicy: refetch ? 'network-only' : undefined
                    })).then((payload) => {
                        if (process.env.DEV) {
                            console.log('QUERY: ' + this._getDataObjectName(payload.data));
                            console.log(payload.data[this._getDataObjectName(payload.data)]);
                        }
                        const scopeData = payload.data[this._getDataObjectName(payload.data)];
                        this[this.crudScope] = scopeData;
                        resolve(scopeData);
                    }).catch(() => {
                        reject();
                    }).then(() => {
                        this.loading = false;
                        this.progressbar(false);
                    });
                }
            });
        },
        /**
         * Refresh data on component (run model query to refetch )
         * @param done
         */
        doRefresh(done) {
            this._read(true).then(() => {
                done();
            });
        },
        /**
         * Get initial mode object data saved once loaded before any modifications made
         */
        getInitialModelComponentData() {
            return Object.assign({}, this.initialModelObject);
        },
        /**
         * Execute on form submit (AFTER form validated successfully)
         * @param args
         */
        doModify(args) {
            args = this._defaults(args);
            return new Promise((resolve, reject) => {
                this.formMode = args.mode || (args.data && args.data.input && args.data.input.id ? 'update' : 'create');
                if (process.env.DEV) {
                    console.log(this.formMode);
                    console.log('MUTATION DATA: ');
                    console.log(args.data);
                }
                this.progressbar(true);
                this.saving = true;
                this.$apollo.mutate({
                    mutation: args.mutation,
                    variables: Object.assign(Object.assign({}, args.data), { input: Object.assign(Object.assign({}, args.data.input), { uid: this.uid }) }),
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    update: this.updateModelData
                }).then((payload) => {
                    //
                    // success
                    //
                    const mutationName = this._getDataObjectName(payload.data), data = payload.data[mutationName];
                    if ( // check data integrity; positive id value OR not empty array must be returned
                    data && // (data.data[mutationName].length || data.data[mutationName].id) &&
                        // custom, form model related data integrity check
                        (typeof args.validateResult !== 'function' || typeof args.validateResult === 'function' && args.validateResult(data))) {
                        if (this.formMode === 'create') {
                            //
                            // create
                            //
                            if (this.apolloCache.create) { // apollo cache already modified
                                if (args.msgSuccessView) {
                                    this.flash(data.msg || args.msgSuccess || `New ${args.label} has been added`);
                                }
                                this._onModifySuccess(args, data);
                            }
                            else { // read modified data from server first
                                this._read(true).then((data) => {
                                    if (args.msgSuccessView) {
                                        this.flash(data.msg || args.msgSuccess || `${args.label} has been added`);
                                    }
                                    this._onModifySuccess(args, data);
                                });
                            }
                        }
                        else {
                            //
                            // update
                            //
                            if (args.msgSuccessView) {
                                this.flash(data.msg || args.msgSuccess || `${args.label} has been updated`);
                            }
                            this._onModifySuccess(args, data);
                        }
                        resolve(data);
                    }
                    else {
                        // fail callback
                        if (typeof args.onFail === 'function') {
                            args.onFail();
                        }
                        this.flash(args.msgFail || `Error while ${this.formMode}ing ${args.label}`, 'negative');
                        reject(false);
                    }
                }).catch(({ graphQLErrors }) => {
                    // failed
                    // if custom graphQLError error thorowed - show message from server instead of default
                    this.formErrors(graphQLErrors, `Error while ${this.formMode}ing ${args.label}`); // , args.form
                    // error callback
                    if (typeof args.onFail === 'function') {
                        args.onFail();
                    }
                    reject(graphQLErrors);
                }).then(() => {
                    this.saving = false;
                    this.progressbar(false);
                });
            });
        },
        _onModifySuccess(args, data) {
            // success callback
            if (typeof args.onSuccess === 'function') {
                try {
                    args.onSuccess(data);
                }
                catch (err) {
                    console.error('CRUD modify onSuccess callback error!');
                    console.log(err);
                }
            }
            // do redirect
            if (args.redirectTo) {
                this._redirect(args.redirectTo, data);
            }
        },
        doDelete(args) {
            if (args.secure === 'prompt') {
                //
                // Show delete confirmation prompt (delete once confirmed)
                //
                this.postponedActionArgs = args;
                this.promptAction = '_delete';
                // invoke prompt (prompt must be defined on target component)
                this.promptConfirm = true;
            }
            else {
                if (args.secure === 'rollback') {
                    //
                    // Show flash message (notify) with rollback option (delayed delete or undo)
                    //
                    const index = args.stock.findIndex((x) => x.id === args.id), removed = {
                        index: index,
                        element: args.stock.splice(index, 1)[0]
                    };
                    this.uiUndoAction(args.msgSuccess || `${args.label} has been deleted`, () => {
                        this._delete(args); // do delete
                    }, () => {
                        args.stock.splice(removed.index, 0, removed.element);
                    });
                }
                else {
                    //
                    // direct delete without any delpay
                    //
                    this._delete(args);
                }
            }
        },
        _delete(args) {
            args = this._defaults(args);
            return new Promise((resolve, reject) => {
                this.formMode = 'delete';
                // this._promptConfirm = false
                this.deleting = true;
                this.progressbar();
                this.$apollo.mutate({
                    mutation: args.mutation,
                    variables: {
                        id: args.id
                    },
                    // eslint-disable-next-line @typescript-eslint/unbound-method
                    update: this.updateModelData
                }).then((payload) => {
                    // success
                    const mutationName = this._getDataObjectName(payload.data), data = payload.data[mutationName], model = args.itemsSubObject === undefined ? data : data[args.itemsSubObject];
                    if (data === args.id || data && model.id) { // check data integrity; data can be just delete ID or deleted model data
                        // set: string, action: string, model: any, itemsSubObject?: string
                        if (this.apolloCache.delete) { // apollo cache already modified
                            /* if (args.secure !== 'rollback') {
                            this.flash(data.msg || args.msgSuccess || `${args.label} has been deleted`, 'positive', {
              
                            })*/
                            if (args.secure !== 'rollback') {
                                this.flash(data.msg || args.msgSuccess || `${args.label} has been deleted`);
                            }
                            this._onModifySuccess(args, data);
                        }
                        else { // read modified data from server first
                            this._read(true).then((data) => {
                                if (args.secure !== 'rollback') {
                                    this.flash(data.msg || args.msgSuccess || `${args.label} has been deleted`);
                                }
                                this._onModifySuccess(args, data);
                            });
                        }
                        resolve(data);
                    }
                    else {
                        // fail callback
                        if (typeof args.onFail === 'function') {
                            args.onFail();
                        }
                        this.flash(args.msgFail || `Error while ${this.formMode}ing ${args.label}`, 'negative');
                        reject(false);
                    }
                }).catch(({ graphQLErrors }) => {
                    // failed
                    // if custom graphQLError error thorowed - show message from server instead of default
                    this.formErrors(graphQLErrors, `Error while ${this.formMode}ing ${args.label}`); // , args.form
                    // error callback
                    if (typeof args.onFail === 'function') {
                        args.onFail();
                    }
                    reject(graphQLErrors);
                }).then(() => {
                    this.deleting = false;
                    this.progressbar(false);
                });
            });
        },
        doDeleteItems(args) {
            return new Promise((resolve, reject) => {
                this.dialog = false;
                this.confirmDelete = null;
                let ids = [], msg = ''; // , tmpDeleted = [], index = null
                if (args.id) {
                    ids = [args.id];
                    msg = `${args.label} has been deleted`;
                }
                else {
                    // get ids from selected array objects
                    ids = args.itemsSubObject ? this.selected.map((item) => item[args.itemsSubObject].id) : this.selected.map((item) => item.id);
                    msg = `Selected ${args.labelPlural} has been deleted`;
                }
                for (const id of ids) { // mark deleting ...
                    try {
                        if (args.itemsSubObject) {
                            (this[args.items][this[args.items].findIndex((x) => x[args.itemsSubObject].id === id)]).deleting = true;
                        }
                        else {
                            (this[args.items][this[args.items].findIndex((x) => x.id === id)]).deleting = true;
                        }
                    }
                    catch (err) { }
                }
                this.deleting = true;
                this.progressbar();
                this.$apollo.mutate({
                    mutation: args.mutation,
                    variables: {
                        ids: ids
                    }
                }).then((data) => {
                    // success
                    this.flash(msg);
                    const mutationName = this._getDataObjectName(data);
                    // remove deleted rows from stack
                    if (data.data[mutationName]) {
                        for (const o of data.data[mutationName]) {
                            try {
                                if (args.itemsSubObject) {
                                    (this[args.items].splice(this[args.items]).findIndex((x) => x[args.itemsSubObject].id === o[args.itemsSubObject].id), 1);
                                }
                                else {
                                    (this[args.items].splice(this[args.items]).findIndex((x) => x.id === o.id), 1);
                                }
                            }
                            catch (err) { }
                        }
                    }
                    this.progressbar();
                    // this.$apollo.queries[items].refresh()
                    this.$apollo.provider.defaultClient.resetStore().then(() => {
                        this.progressbar(false);
                    });
                    resolve(data.data[mutationName]);
                }).catch(({ graphQLErrors }) => {
                    // failed
                    this.flash(`Error while deleting ${args.label}`, 'negative');
                    this.progressbar(false);
                    // this.$apollo.queries.companies.stop()
                    // this.console.queries.companies.refetch()
                    // this.logGraphQLErrors(graphQLErrors)
                    reject(graphQLErrors);
                }).then(() => {
                    this.deleting = false;
                });
            });
        },
        /**
         * Confirm action (Confirmation Dialog)
         */
        promptConfirmed() {
            this[this.promptAction](this.postponedActionArgs);
            this.promptReset();
        },
        /**
         * Cancel action (Confirmation Dialog)
         */
        promptCanceled() {
            this.promptReset();
        },
        promptReset() {
            this.promptAction = null;
            this.postponedActionArgs = { model: {} };
        },
        /**
         * Handle molde object data read from server (ONLY THEN!)
         *
         * @param data          model object data
         * @param defaults      default model object data
         * @param allowEmpty    if true allow empty model object data (INSERT)
         */
        onModelRead(data, defaults = {}, allowEmpty = false) {
            const dataClone = _.cloneDeep(data);
            // format data
            this.formatModelObjectData(dataClone);
            // remember initial state read from server
            this.initialModelObject = Object.assign(Object.assign({}, defaults), dataClone);
            // check model data given
            if (data && data.id) {
                return dataClone;
            }
            else {
                if (allowEmpty) { // allow empty model
                    return dataClone || defaults;
                }
                else { // model must exists
                    // show message and go back
                    this.flash(this.label + ' not found', 'warning');
                    this.$router.go(-1);
                    return defaults;
                }
            }
        },
        formatModelObjectData(data) {
            return this._str2json(data);
        },
        _str2json(obj) {
            for (const key in obj) {
                const v = obj[key];
                //if (typeof v === 'object' || !v) {
                if (key.includes('_json_str')) {
                    const fieldname = key.replace('_json_str', '_json');
                    if (v && typeof v === 'string') {
                        obj[fieldname] = JSON.parse(v);
                    }
                    else {
                        obj[fieldname] = {}; // input is null or empty
                    }
                    // unset property with value defined as JSON string;
                    // if not -> property value stored on component (appolo query) model
                    // will be overwritten by value read from JSON string property
                    delete obj[key];
                }
                else if (typeof v === 'object' || !v) {
                    this._str2json(v);
                }
                // remove `__typename` property form object (added by apollo; to avoid "Variable "$input" got invalid value" error on crud INSERT/UPDATE actions)
                if (key === '__typename') {
                    delete obj[key];
                }
                //}
            }
            return obj;
        },
        /**
         * Update model data; update VueApollo cache for current Type
         */
        updateModelData(store, data) {
            const mutationName = this._getDataObjectName(data.data), model = data.data[mutationName], queryData = this.operations.read && typeof (this.operations.read) !== 'string' ? store.readQuery(this.operations.read) : null, queryName = queryData ? this._getDataObjectName(queryData) : null;
            if (process.env.DEV) {
                console.log('MODE: ' + this.formMode);
                console.log('MUTATION: ' + mutationName);
                console.log(model);
                console.log('QUERY: ' + queryName);
                console.log(queryData);
            }
            if (this.formMode !== 'update') {
                //
                // handle apollo cache on create
                //
                if (this.formMode === 'create' && this.apolloCache.create) {
                    if (queryData && queryName && queryData[queryName]) {
                        // flat array of objects
                        queryData[queryName].push(model);
                        // write to cache
                        store.writeQuery(Object.assign(Object.assign({}, this.operations.read), { data: queryData }));
                    }
                }
                //
                // handle apollo cache on delete
                //
                if (this.formMode === 'delete' && this.apolloCache.delete) {
                    if (queryData && queryName && queryData[queryName]) {
                        // flat array of objects
                        const index = queryData[queryName].findIndex((item) => item.id === model.id);
                        if (index !== -1) {
                            queryData[queryName].splice(index, 1);
                            // write to cache
                            store.writeQuery(Object.assign(Object.assign({}, this.operations.read), { data: queryData }));
                        }
                    }
                }
            }
            else {
                // do noting - apollo updates automatically
            }
        },
        _setForm(formRef) {
            return formRef === undefined ? this.$refs.form : this.$refs[formRef];
        },
        /**
         * Convert validation error messages returned from GraphQL server to our needs.
         * Executed after server create/update/delete submit failed and at least one field invlaid value
         *
         * @param {*} graphQLErrors     object containing GraphQL validation results from server
         * @param {String} msg          custom, common for all invalid form flash message shown on top
         * @returns {*}                 object with validation results, ex: { invali_field.name: { msg: "Invalid Message", result: true }, ... }
         */
        formErrors(graphQLErrors, msg) {
            // let form = this._setForm(formRef)
            // collect invalidOnServer form input names and error message(s):
            // ['fieldname' => ['msg1', 'msg2', ...]]
            const invalidOnServer = [], invalidOnServerValues = [];
            if (graphQLErrors) {
                for (const bag of graphQLErrors) {
                    if (bag.extensions && bag.extensions.validation) {
                        for (const field in bag.extensions.validation) {
                            for (const msg in bag.extensions.validation[field]) {
                                // field can contain input name (ex. 'input.email'); use only 2nd part ('email')
                                if (!invalidOnServer[field])
                                    invalidOnServer[field] = [];
                                invalidOnServer[field].push(bag.extensions.validation[field][msg]); // array of messages
                                invalidOnServerValues[field] = this._getInputValue(field);
                            }
                        }
                    }
                    else {
                        // no validation errors messages (network errors)
                    }
                }
            }
            if (graphQLErrors && graphQLErrors[0] && graphQLErrors[0].extensions.category === 'validation') { // flash only form validation errors here
                const srvErrMsg = graphQLErrors[0].message;
                this.flash(graphQLErrors && srvErrMsg ? srvErrMsg : msg, 'warning');
            }
            this.invalidOnServer = invalidOnServer;
            this.invalidOnServerValues = invalidOnServerValues;
            this.handleInvalidTabs();
            return invalidOnServer;
        },
        /**
         * Collect all invalid fields and related messages validation results.
         * Use for server side validation of child components for hasOne/hasMany relationships
         * use: (on model form component (parent for hasMany) )
         *  hasManyChildComponent(
         *    :inputErrors="inputErrors()"
         *    // ...
         *  )
         * @returns Object        ex, { invali_field.name: { msg: "Invalid Message", result: true }, ... }
         */
        inputsErrors() {
            let invalidInputs = {};
            // eslint-disable-next-line @typescript-eslint/no-for-in-array
            for (const field in this.invalidOnServer) {
                invalidInputs = Object.assign(Object.assign({}, invalidInputs), { [field]: this.inputErr(field) });
            }
            return invalidInputs;
        },
        /**
         * Reset server side validation (invalid/error inputs)
         */
        resetInputsErrors() {
            this.invalidOnServer = [];
        },
        /**
         * Single invalid input validation results; use:
         *    q-input(
         *      :error="inputErr('field_name').result"
         *      :error-message="inputErr('field_name').msg"
         *    )
         * OR helpers:
         *    q-input(
         *      :error="err('field_name')"
         *      :error-message="errMsg('field_name')"
         *    )
         */
        inputErr(field, msg) {
            const value = this._getInputValue(field);
            // prepare invalid message
            let invMsg = this.invalidOnServer[field];
            if (value && this.invalidOnServerValues[field] !== value) { // input value is equal to invlaid value checked on server
                // show error message only once (until next server side validation)
                invMsg = false;
            }
            return {
                result: invMsg ? true : false,
                msg: invMsg ? (msg || invMsg.join('<br>')) : undefined
            };
        },
        scrollToFirstInvalid(el) {
            // scroll to first invalid input
            // this.$q.goTo('form', { offset: 64 + 5 }) // scroll to form top - topbar height and margin
            // Quasar handle it on internal validation, for server validation it is required
            const { getScrollTarget, setVerticalScrollPosition } = quasar_1.scroll;
            // takes an element object
            function scrollToElement(el) {
                const target = getScrollTarget(el);
                const offset = el.offsetTop;
                const duration = 1000;
                setVerticalScrollPosition(target, offset, duration);
            }
            scrollToElement(el);
        },
        //
        // Relationships
        //
        randomId() {
            return 'rnd' + Math.random();
        },
        markDeleted(id, set = 'default') {
            if (!this.deleted[set])
                this.deleted[set] = [];
            if (id.indexOf('rnd') < 0) { // only if this item exists already on server
                this.deleted[set].push(id);
            }
        },
        hasMany(input, set = 'default', fieldsToRemove = []) {
            // lighthouse GraphQL format
            const items = [...input], // clone
            hasMany = {
                create: [],
                update: [],
                delete: this.deleted[set]
            };
            // added or updated
            for (const item of items) {
                if (!item.id || item.id.indexOf('rnd') > -1) {
                    // add
                    delete item.id; // for create id must be not defined
                    hasMany.create.push(item);
                }
                else {
                    // update
                    // delete item.__typename // added automatically by vue-apollo
                    hasMany.update.push(item);
                }
                // remove no needed fields
                for (const f of fieldsToRemove) {
                    delete item[f];
                }
            }
            return hasMany;
        },
        /**
         * Executed on each tab panel changed.
         * Should be asigned oq QTabPanel component ex:
         * q-tab-panels(v-model="tab" ref="tabPanels" @transition="formTabChanged")
         *
         * @param newValue
         * @param oldValue
         *
         * @return void
         */
        formTabChanged() {
            if (this.$refs.tabPanels && this.tabs2validate) { // form is submitting (tabs2validate!==false)
                if (this.tabs2validate.length) { // still some panel(s) to validate (excluding current)
                    // do validate form inputs placed on current tab panel
                    this.$refs.form.validate().then((success) => {
                        if (success) { // this panel is valid; get and go to next panel to be validated
                            // const panel: any = (this.tabs2validate as any).shift()
                            this.$refs.tabPanels.goTo(this.tabs2validate.shift());
                        }
                        else { // one of panel inputs is invalid - stops here (clear array of panels to check)
                            this.tabs2validate = false; // break submitting
                        }
                    });
                }
                else { // this is last panel to validate - submit (triggers validation first) to avid double check
                    // do validate form inputs placed on current tab panel
                    this.$refs.form.validate().then((success) => {
                        if (success) { // this panel is valid; get and go to next panel to be validated
                            this._formSubmit();
                        }
                        else { // one of panel inputs is invalid - stops here (clear array of panels to check)
                            this.tabs2validate = false; // break submitting
                        }
                    });
                    /*this.$refs.form.validate().then((success: any) => {
                      if (success) {
                        // all panels inputs are valid - do submit
                        this.$refs.form.submit();
                        this.progressbar()
                      }
                    })*/
                    //this.tabs2validate = false // break submitting (no more panel to validate)
                }
            }
            else {
                // just tab changed
            }
        },
        /**
         * On submit button hit enter
         * (there can be inputs validation in background - show "loading..." to avoid confusion)
         *
         * @param forceSubtmit      if true force form validation and submit.
         *                          Note: to aviod double submit submit button must be "button" type, not "submit"
         * @param tabs2validate     array of tabs panel names which inputs needs to be validated on submit
         *                          Note: target component must have 'tabPanels' property defined ex:
         *                          (...) , mounted () { this.$refs.tabPanels = this.$refs.tabPanels } (...)
         */
        onSubmitBtnHit(forceSubtmit = false, tabs2validate) {
            if (forceSubtmit) {
                if (this.$refs.tabPanels && tabs2validate) { // form inputs on separate tabs
                    this.tabPanelOnSubmit = this.$refs.tabPanels.modelValue; // tabs active tab panel when user hits submit
                    // go throu all tabs containing inputs required to validate
                    // Once tab selected do this particular tab validation
                    this.tabs2validate = tabs2validate;
                    // switch to first tab; validation is made on q-tab-panels() > @transition event handle (QtabPanel)
                    // @ see this.formTabChanged
                    // ex. q-tab-panels(v-model="tab" ref="tabPanels" @transition="formTabChanged")
                    let panel = this.tabs2validate.shift();
                    if (panel === this.$refs.tabPanels.modelValue) { // if first panel to check is current panel tabPanels.goTo will not be executed
                        if (this.tabs2validate.length) {
                            this.$refs.form.validate().then((success) => {
                                if (success) {
                                    if (this.tabs2validate.length) { // there are more panel(s) to validate
                                        // begin chain of tabs panels processing
                                        panel = this.tabs2validate.shift();
                                        this.$refs.tabPanels.goTo(panel);
                                    }
                                    else { // only one panel - submit
                                        this._formSubmit();
                                        return false;
                                    }
                                }
                                else { // one or more inputs invalid on this panel
                                    this.tabs2validate = false;
                                    return false;
                                }
                            });
                        }
                        else { // this is only panel to validate - submit (triggers validation first) to avid double check
                            this._formSubmit();
                            return false;
                        }
                    }
                    else {
                        // begin chain of tabs panels processing
                        this.$refs.tabPanels.goTo(panel);
                    }
                    return true;
                }
                else { // no tabs - single view form - just validate all inputs
                    this.$refs.form.validate().then((success) => {
                        if (success) {
                            this._formSubmit();
                            return false;
                        }
                        else { // one or more inputs invalid
                            return false;
                        }
                    });
                }
            }
            else { // submit (type) button submits form
                return true;
            }
        },
        onValidationSuccess() {
            // console.log('On validataion success')
            // this.saving = false
        },
        onValidationError() {
            // console.log('On validataion error')
            // this.saving = false
            this.progressbar(false);
            this.flash(this.msgInvalid, 'warning');
        },
        // inputs server side validation helpers; use:
        //    :error="err('field.name')"
        //    :error- message="errMsg('field.name')"
        err(field) {
            const ie = this.inputsErrors();
            return ie[field] ? ie[field].result : false;
        },
        errMsg(field) {
            const ie = this.inputsErrors();
            return ie[field] ? ie[field].msg : '';
        },
        // ---
        _redirect(redirectTo, data) {
            const defaultRedirect = { params: { model: data, refetch: true } };
            if (typeof redirectTo === 'string') {
                if (redirectTo === 'prev') { // got prev route
                    // this.$router.push({ ...(this.prevRoute as any), ...defaultRedirect.params })
                    // TODO: remember prevRoute and use here instead of using: router.back()
                    this.$router.back();
                }
                else {
                    this.$router.push({ path: redirectTo, params: Object.assign({}, defaultRedirect.params) });
                }
            }
            else {
                this.$router.push(Object.assign(Object.assign({}, redirectTo), { params: Object.assign(Object.assign({}, defaultRedirect.params), redirectTo.params) }));
            }
        },
        _defaults(args) {
            if (!args.label) {
                args.label = this.label;
            }
            if (args.msgSuccessView === undefined) {
                args.msgSuccessView = true;
            }
            if (!args.redirectTo) {
                args.redirectTo = this.redirectTo;
            }
            return args;
        },
        /**
         * Rip from returned forms ever data object used query/mutation name
         * @param data    data object of payload returned from server
         */
        _getDataObjectName(data) {
            try {
                return Object.keys(data)[0].toString();
            }
            catch (error) {
                return '';
            }
        },
        _formSubmit() {
            if (this.$refs.tabPanels && this.tabPanelOnSubmit) {
                this.$refs.tabPanels.goTo(this.tabPanelOnSubmit); // restore initial (on submit hit) tabs panel
            }
            this.$refs.form.submit();
            this.progressbar();
            this.tabs2validate = false;
        },
        /**
         * Get current, actual form model field value (input value)
         *
         * @param {String} field      target field; ex. name | periods.0.name | profile.phone
         * @returns {Mixed}
         */
        _getInputValue(field) {
            // ex. [orders][1][quote] OR [subscription][ends_at] OR [name]
            const ch = field.split('.');
            let value;
            if (this.modelObjectName) {
                try {
                    value = ch[2] !== undefined ? this[this.modelObjectName][ch[0]][ch[1]][ch[2]] : (ch[1] !== undefined ? this[this.modelObjectName][ch[0]][ch[1]] : this[this.modelObjectName][ch[0]]);
                }
                catch (error) { }
            }
            return value;
        },
        /**
         * Get vue q-input object for given field name
         * @param {String} field
         * @returns Any
         */
        _getNodeForFieldInput(field) {
            let node;
            // first right input on main form or child,sub-forms on components
            if (this.$refs[field]) { // root form input
                node = this.$refs[field];
            }
            else { // input is on some sub-form
                for (const el of Object.keys(this.$refs)) {
                    if (this.$refs[el] && this.$refs[el].$refs && this.$refs[el].$refs[field]) {
                        node = this.$refs[el].$refs[field][0]; // Array of components? - get first
                    }
                }
            }
            return node;
        },
        /**
         * Get tab name for given field input
         * @param field
         * @returns {String}     Qtabs current Qtab name
         */
        _getTabNameForInput(field) {
            let node = this._getNodeForFieldInput(field);
            if (node) {
                while (node.$parent) {
                    if (node.$parent.$el && node.$parent.$el.className === 'q-tab-panel') { // this is tab!
                        return node.$parent.name; // returns QTab tab name
                    }
                    node = node.$parent;
                }
            }
            return null;
        },
        /**
         * If form on tabs - select tab having first invalid input and mark other tabs containing invalid inputs
         * @param {Bool} focusFirstInvalidInputTab
         * @param {Bool} markInvalidInputsTabs
         *
         * @returns {Void}
         */
        handleInvalidTabs(focusFirstInvalidInputTab = true, markInvalidInputsTabs = true) {
            // get first invalid
            let tabsWithInvalidInputs = [], firstInvalid = '';
            // eslint-disable-next-line @typescript-eslint/no-for-in-array
            for (const field in this.invalidOnServer) {
                const tabName = this._getTabNameForInput(field);
                if (tabName) {
                    tabsWithInvalidInputs.push(tabName);
                }
                if (!firstInvalid) {
                    firstInvalid = field;
                }
            }
            tabsWithInvalidInputs = Array.from(new Set(tabsWithInvalidInputs)); // make unique
            if (tabsWithInvalidInputs.length) {
                // switch to tab containing first invalid input value
                if (this.$refs.tabPanels && focusFirstInvalidInputTab) {
                    this.$refs.tabPanels.goTo(tabsWithInvalidInputs.shift());
                    setTimeout(() => {
                        // scroll to & focus first invalid input
                        const firstInvalidInput = this._getNodeForFieldInput(firstInvalid);
                        if (firstInvalidInput) {
                            firstInvalidInput.focus();
                        }
                    }, 500);
                }
                // mark tab with tab alert (as containing invalid inputs and require action)
                if (markInvalidInputsTabs) {
                    tabsWithInvalidInputs.forEach((name) => {
                        try {
                            this.tabAlert[name] = 'negative';
                        }
                        catch (err) { }
                    });
                }
            }
            /*
            try {
              if (this.$refs.form.validate()) {
                this.scrollToFirstInvalid()
              }
            } catch (err) {
              console.log(err)
            }
            */
            // TODO: scroll to first invalid after server validation failed
        }
    }
});
